import { Button, ButtonKind, IButton } from '$components/Button';
import { Icon } from '$components/Icon';
import { IconType } from '$components/Icon';
import { ModalToggleButton } from '$components/ModalToggleButton';
import {
  FragmentType,
  useFragment as getFragment,
} from '$contentful-gql/index';
import { makeUrlFromUrlFragment } from '$providers/Url';
import Link from 'next/link';
import { HTMLAttributes } from 'react';

import { ctaFragment, urlFragment } from './common/fragments';

export function CtaProvider(
  props: {
    item: FragmentType<typeof ctaFragment>;
    inContentBlock?: boolean;
  } & HTMLAttributes<HTMLElement> &
    IButton,
) {
  const { item, size, buttonType, inContentBlock = false } = props;
  const pageUrl = getFragment(ctaFragment, item);

  switch (pageUrl?.__typename) {
    case 'Cta': {
      const url = getFragment(urlFragment, pageUrl.url);

      const buttonArgs = {
        inContentBlock: inContentBlock,
        buttonType: buttonType,
        kind: pageUrl.template as ButtonKind,
        size: size,
        iconRight:
          pageUrl.icon !== null &&
          pageUrl.iconPosition !== null &&
          pageUrl.iconPosition === 'Right' ? (
            <Icon
              name={pageUrl.icon as IconType}
              fill={
                pageUrl.template === 'primary'
                  ? typeof buttonType === 'undefined' ||
                    buttonType === null ||
                    buttonType === 'light'
                    ? 'fill-white group-hover:fill-white duration-300'
                    : 'fill-grey-80 group-hover:fill-white duration-300'
                  : typeof buttonType === 'undefined' ||
                    buttonType === null ||
                    buttonType === 'light'
                  ? 'fill-grey-80 group-hover:fill-50 duration-300'
                  : 'fill-white group-hover:fill-50 duration-300'
              }
            />
          ) : null,
        iconLeft:
          pageUrl.icon !== null &&
          pageUrl.iconPosition !== null &&
          pageUrl.iconPosition === 'Left' ? (
            <Icon
              name={pageUrl.icon as IconType}
              fill={
                pageUrl.template === 'primary'
                  ? typeof buttonType === 'undefined' ||
                    buttonType === null ||
                    buttonType === 'light'
                    ? 'fill-white group-hover:fill-white duration-300'
                    : 'fill-grey-80 group-hover:fill-white duration-300'
                  : typeof buttonType === 'undefined' ||
                    buttonType === null ||
                    buttonType === 'light'
                  ? 'fill-grey-80 group-hover:fill-50 duration-300'
                  : 'fill-white group-hover:fill-50 duration-300'
              }
            />
          ) : null,
      };
      const linkProps = {
        ...(pageUrl.newTab
          ? { target: '_blank', rel: 'noindex nofollow' }
          : {}),
      };

      if (url?.linkType === 'formContact') {
        return (
          <ModalToggleButton
            {...buttonArgs}
            url={url}
            id={pageUrl.name}
            type={'contactForm'}
            text={pageUrl.name}
          />
        );
      } else if (url?.linkType === 'formNewsletter') {
        return (
          <ModalToggleButton
            {...buttonArgs}
            type={'newsletterSignup'}
            text={pageUrl.name}
          />
        );
      }

      return (
        <Link href={makeUrlFromUrlFragment({ url })} {...linkProps}>
          <Button {...buttonArgs}>{pageUrl.name}</Button>
        </Link>
      );
    }
  }
  return null;
}
